import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Products from "../src/pages/Products.jsx";
import ProductDetail from "./pages/ProductDetail";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Footer from "./pages/Footer";     // ✅ footer
import RecipePage from "../src/pages/RecipePage"; 

function App() {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/product/:id" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} /> 
          <Route path="/recipes" element={<RecipePage />} /> {/* ✅ fixed spelling */}
        </Routes>
        <Footer /> {/* ✅ always at bottom */}
      </>
    </Router>
  );
}

export default App;
